import { InternalBet, MachineSymbol } from '@cgs/data-access';
import { BaseStore } from '@cgs/shared';

export interface ILaunchParams<T = unknown> {
  bets: InternalBet[];
  defaultBet: number;
  maxLines: number;
  symbols: MachineSymbol[];
  betMultiplier: number;
  cheatEnabled: boolean;
  cheatConfigs: string[];
  cheatCommands: string[];
  cheatReels: boolean;
  customCheatInput: boolean;
  gameConfig: T;
  language: string;
}

export const LAUNCH_PARAMS_STORE_TOKEN = Symbol('LAUNCH_PARAMS_STORE_TOKEN');

const DEFAULT_PARAMS: ILaunchParams = {
  bets: [],
  defaultBet: 0,
  maxLines: 0,
  symbols: [],
  betMultiplier: 1,
  cheatEnabled: false,
  cheatConfigs: [],
  cheatCommands: [],
  cheatReels: false,
  customCheatInput: false,
  gameConfig: {},
  language: 'en',
};

export class LaunchParamsStore<T = unknown> extends BaseStore<ILaunchParams<T>> {
  constructor(launchParams?: Partial<ILaunchParams<T>>) {
    const state = { ...DEFAULT_PARAMS, ...launchParams } as ILaunchParams<T>;

    super(state);
  }
}
